import React from 'react';
import { createPortal } from 'react-dom';
import { OVERLAY_ID, MODAL_ID, FORM_ID } from './wafConfig';
import './AWSWAFCaptchaModal.css';

/// Host element for the AWS WAF CAPTCHA challenge.
///
/// Rendered hidden and portalled to document.body so the SDK has a stable
/// container to draw into. `captchaFetch` toggles visibility; nothing is shown
/// unless a challenge is actually in progress.
///
/// The `.modal` class supplies the app's full-screen dim backdrop from
/// custom.css; `AWSWAFCaptchaModal.css` centres a bounded white card inside it.
/// That sizing is not cosmetic: the SDK is asked to render with `dynamicWidth`,
/// so it measures `#wafCaptchaForm` and draws the puzzle to whatever width it
/// finds. Unbounded, the puzzle filled the 1440px viewport, stood ~800px tall
/// and put the Confirm button below the fold. The CSS must therefore be applied
/// before `renderCaptcha` runs - the SDK does not reflow if the container is
/// resized afterwards - which is why it is imported here, with the host, rather
/// than injected at challenge time.
///
/// The earlier version called `loadScript()` from an effect on every render.
/// Loading is now the responsibility of `captchaFetch`, so the SDK is fetched
/// only when someone actually submits — a visitor who never uses the form never
/// downloads it.
export function AWSWAFCaptchaModal() {
  return createPortal(
    <div className="overlay" id={OVERLAY_ID} style={{ display: 'none' }}>
      <div className="modal" id={MODAL_ID} style={{ display: 'none' }}>
        <div id={FORM_ID} />
      </div>
    </div>,
    document.body
  );
}
